"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const HeartFilled = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M16.5 2.95a5.5 5.5 0 015.5 5.5c0 3.466-1.81 6.725-4.793 9.707a27.813 27.813 0 01-4.271 3.483c-.196.129-.34.218-.422.267a1 1 0 01-1.028 0 13.21 13.21 0 01-.422-.267 27.813 27.813 0 01-4.271-3.483C3.81 15.175 2 11.916 2 8.45a5.5 5.5 0 0110-3.163 5.493 5.493 0 014.5-2.337z" })));
exports.default = HeartFilled;
//# sourceMappingURL=index.js.map